/* istanbul ignore next */
export default {
    borderColor: 'var(--secondary-color)',
    fontFamily: 'var(--font-family)',
    control: (baseStyles, state) => ({
      ...baseStyles,
      backgroundColor: 'var(--background-color)',
      borderColor: state.isFocused
        ? 'var(--secondary-color)'
        : '#e5e5ea',
      borderWidth: '0.5px',
      borderRadius: '8px',
      border: '1px solid var(--rs-border-primary)',
      minHeight: '44px',
      boxShadow: state.isFocused ? '0 0 0 2px rgba(0, 109, 158, 0.1)' : 'none',
      '&:hover': {
        borderColor: 'var(--secondary-color)',
      },
    }),
    input: (base) => ({
      ...base,
      color: 'var(--text-color)',
    }),
    placeholder: (base) => ({
      ...base,
      color: '#8e8e93',
      fontSize: '14px',
    }),
    singleValue: (base) => ({
      ...base,
      color: 'var(--text-color)',
      fontSize: '14px',
    }),
    option: (styles, { isDisabled, isFocused, isSelected }) => ({
      ...styles,
      backgroundColor: isDisabled
        ? 'transparent'
        : isSelected
        ? 'var(--primary-color)'
        : isFocused
        ? 'var(--secondary-color)'
        : 'var(--background-color)',
      color: isDisabled 
        ? '#8e8e93' 
        : isSelected || isFocused 
        ? 'white' 
        : 'var(--text-color)',
      cursor: isDisabled ? 'not-allowed' : 'pointer',
      ':active': {
        backgroundColor: isSelected ? 'var(--primary-color)' : 'var(--secondary-color)',
      },
    }),
    menu: (base) => ({
      ...base,
      backgroundColor: 'var(--background-color)',
      border: '1px solid #e5e5ea',
      borderRadius: '8px',
      boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
      zIndex: 9999,
    }),
    menuList: (base) => ({
      ...base,
      backgroundColor: 'var(--background-color)',
      borderRadius: '8px',
      padding: '4px',
      '::-webkit-scrollbar': {
        width: '8px',
        height: '0px',
      },
      '::-webkit-scrollbar-track': {
        background: 'var(--background-color)',
        borderRadius: '4px',
      },
      '::-webkit-scrollbar-thumb': {
        background: 'var(--secondary-color)',
        borderRadius: '4px',
      },
      '::-webkit-scrollbar-thumb:hover': {
        background: 'var(--primary-color)',
      },
        zIndex: 99999,
    }),
    dropdownIndicator: (base, state) => ({
      ...base,
      color: '#8e8e93',
      '&:hover': {
        color: 'var(--secondary-color)',
      },
      transform: state.selectProps.menuIsOpen ? 'rotate(180deg)' : null,
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
  };